import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=16c8385a&scoped=true"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=16c8385a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8385a",
  null
  
)

export default component.exports